import { useEffect, useRef } from 'react'

/** Setzt beim Sichtwerden die Klasse "sichtbar" (CSS-Klasse .einblenden). */
export function useEinblenden<T extends HTMLElement>(verzoegerungMs = 0) {
  const ref = useRef<T>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return undefined
    if (typeof IntersectionObserver === 'undefined') {
      element.classList.add('sichtbar')
      return undefined
    }
    const beobachter = new IntersectionObserver(
      eintraege => {
        for (const eintrag of eintraege) {
          if (!eintrag.isIntersecting) continue
          window.setTimeout(() => element.classList.add('sichtbar'), verzoegerungMs)
          beobachter.unobserve(eintrag.target)
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' },
    )
    beobachter.observe(element)
    return () => beobachter.disconnect()
  }, [verzoegerungMs])

  return ref
}
